import { render } from "./About.vue?vue&type=template&id=ec88c12a&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=ec88c12a&lang=postcss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec88c12a"]])

export default __exports__